(function () {
    'use strict';

    angular.module('GorillaBoy.directives')
    .directive('searchMenuToggle', ['$rootScope', '$document', 'SignalProvider', function($rootScope, $document, SignalProvider) {
        return {
            link: function ($scope, element, attr) {
                function closeSearchMenuOnEsc(event) {
                    var KEYCODE_ESCAPE = 27;
                    if (event.keyCode === KEYCODE_ESCAPE) {
                        $rootScope.$broadcast(SignalProvider.Search.HideSearchMenu);
                    }
                }

                $scope.toggleSearchMenu = function () {
                    if (!$scope.searchViewModel.isSearchMenuOpen) {
                        //toggle the value here. We need this because the search-menu is not rendered yet.
                        $scope.searchViewModel.isSearchMenuOpen = !$scope.searchViewModel.isSearchMenuOpen;
                        $document.on("keydown", closeSearchMenuOnEsc);
                    } else {
                        $rootScope.$broadcast(SignalProvider.Search.HideSearchMenu);
                        $document.off("keydown", closeSearchMenuOnEsc);
                    }
                };
            },
        };
    }])
    .directive('searchMenu', ['QuerySearchManager', 'SearchCommons', 'authenticatedUser', 'TypeaheadService',
                           'MessageManager', 'MessageProvider', '$q', '$rootScope', '$log', 'SignalProvider', '$timeout',
      function (QuerySearchManager, SearchCommons, authenticatedUser, TypeaheadService,
                            MessageManager, MessageProvider, $q, $rootScope, $log, SignalProvider, $timeout) {
        return {
            templateUrl: './search/search_menu.html',
            scope: true,
            link: function ($scope, element, attrs) {

                function toggleSearchOpenFlag() {
                    $scope.searchViewModel.isSearchMenuOpen = !$scope.searchViewModel.isSearchMenuOpen;
                }

                //We need to animate it as soon as it is rendered. The reason is it's used in ngIF now.
                // Converted to IIFE
                $timeout(function(){
                      var searchMenuBlurred = document.getElementsByClassName("search-menu-blurred");
                      angular.forEach(searchMenuBlurred, function(item){
                          angular.element(item).css('transition', '400ms');
                      });
                      $("#search-menu-background").css('transition', '400ms');

                      angular.forEach(searchMenuBlurred, function(item){
                          angular.element(item).css('filter', 'blur(3px)');
                      });

                      $("#search-menu-background").css("display", "block");
                      // show border bottom after the animation of height is done.
                      $("#search-menu-modal").animate({height: "410px"}, 400, function(){
                          $("#search-menu-modal").css('border-bottom', '1px solid #E0E0E0');
                          $("#search-menu-modal").css('overflow', 'visible');
                      });
                }, false);

                /**
                 * Focus Trap: move focus from search button to search box when pressing tab while menu is open.
                 */
                function focusSearchBoxOnTab(event) {
                    if (event.keyCode === 9 && !event.shiftKey) {
                        angular.element('#search_box').focus();
                        event.preventDefault();
                    }
                }

                /**
                 * Focus Trap: move focus from search box to search button when pressing shift+tab while menu is open.
                 */
                function focusSearchButtonOnShiftTab(event) {
                    if (event.keyCode === 9 && event.shiftKey) {
                        angular.element('#search_button').focus();
                        event.preventDefault();
                    }
                }

                $scope.$on(SignalProvider.Search.HideSearchMenu, function(event, args){
                      angular.element('#search_button').off('keydown', focusSearchBoxOnTab);
                      angular.element('#search_box').off('keydown', focusSearchButtonOnShiftTab);
                      var searchMenuBlurred = document.getElementsByClassName("search-menu-blurred");
                      angular.forEach(searchMenuBlurred, function(item){
                          angular.element(item).css('transition', '400ms');
                      });
                      $("#search-menu-background").css('transition', '400ms');

                      angular.forEach(searchMenuBlurred, function(item){
                          angular.element(item).css('filter', '');
                      });

                      $("#search-menu-background").css("display", "none");
                      // Hidding border should be faster that height animation, to make it more natural.
                      $("#search-menu-modal").animate({'border-bottom': 'none'}, 200);
                      $("#search-menu-modal").animate({height: "0px"}, 400, function(){
                          $("#search-menu-modal").css('overflow', 'hidden');
                          $rootScope.$apply(toggleSearchOpenFlag);
                      });
                });

                /* Input:
                   {
                      "customkey1": {
                          attr: "value1"
                      },
                      "customkey2": {
                          attr: "value2"
                      }
                   }
                   Output:
                   [{key: "customkey1", attr: "value1"}, {key: "customkey2", attr: "value2"}]
                */
                function createArrayFromObject(object){
                    var array = [];
                    for(var key in object) {
                        var copyOfObjectValue = _.clone(object[key]);
                        copyOfObjectValue.key = key;
                        array.push(copyOfObjectValue);
                    }

                    return array;
                }

                function removeFromArray(array, keyObject) {

                    var objIdx = _.findIndex(array, function(item){
                        return item.key === keyObject;
                    });

                    var elem = null;
                    if (objIdx >= 0) {
                      elem = array[objIdx];
                      array.splice(objIdx, 1);
                    }

                    return elem;
                }

                var SIMPLE_QUOTES_REGEX = /[\"\']/g;

                $scope.KEYWORDS = QuerySearchManager.CONSTANTS.KEYWORDS;
                $scope.SEARCH_LOCATIONS_ARRAY = createArrayFromObject(SearchCommons.SEARCH_LOCATIONS);
                $scope.SEARCH_TIMES_ARRAY = createArrayFromObject(SearchCommons.SEARCH_TIMES);
                $scope.SEARCH_FILE_TYPES_ARRAY = createArrayFromObject(SearchCommons.SEARCH_FILE_TYPES);
                $scope.SEARCH_SCOPES_ARRAY = createArrayFromObject(SearchCommons.SEARCH_SCOPES);

                $scope.CUSTOM_TIME = removeFromArray($scope.SEARCH_TIMES_ARRAY,
                                      SearchCommons.SEARCH_FIXED_OPTIONS.TIMES.CUSTOM);

                // File type radio buttons
                var allIdx = _.findIndex($scope.SEARCH_FILE_TYPES_ARRAY, function(item){
                                        return item.key === 'all';
                                    });
                $scope.ALL_FILES_TYPES = $scope.SEARCH_FILE_TYPES_ARRAY[allIdx];
                $scope.FOLDERS_FILE_TYPE = removeFromArray($scope.SEARCH_FILE_TYPES_ARRAY, SearchCommons.SEARCH_FIXED_OPTIONS.FILE_TYPES.FOLDERS);
                $scope.FILES_FILE_TYPE = removeFromArray($scope.SEARCH_FILE_TYPES_ARRAY, SearchCommons.SEARCH_FIXED_OPTIONS.FILE_TYPES.FILES);

                $scope.SEARCH_FILE_TYPE_OPTIONS = [];
                $scope.SEARCH_FILE_TYPE_OPTIONS.push( $scope.ALL_FILES_TYPES );
                $scope.SEARCH_FILE_TYPE_OPTIONS.push( $scope.FOLDERS_FILE_TYPE );
                $scope.SEARCH_FILE_TYPE_OPTIONS.push( $scope.FILES_FILE_TYPE );

                // Options in columns
                var columns = 2;
                $scope.SEARCH_TIMES_ARRAY_CHUNKS = _.chunk($scope.SEARCH_TIMES_ARRAY, columns);
                $scope.SEARCH_FILE_TYPES_ARRAY_CHUNKS = _.chunk($scope.SEARCH_FILE_TYPES_ARRAY, columns);
                $scope.SEARCH_SCOPES_ARRAY_CHUNKS = _.chunk($scope.SEARCH_SCOPES_ARRAY, columns);

                $scope.keywordsOptionsValue = {};
                $scope.dateFormat = QuerySearchManager.CONSTANTS.DATE_FORMAT;
                $scope.datePickerOptions = {
                    maxDate: 0,
                    dateFormat: $scope.dateFormat
                };


                // default values
                $scope.ALL_LOCATION_KEY = $scope.SEARCH_LOCATIONS_ARRAY[0].key;
                $scope.ALL_TIME_KEY = $scope.SEARCH_TIMES_ARRAY[0].key;
                $scope.CURRENT_FOLDER_KEY = $scope.SEARCH_LOCATIONS_ARRAY[4].key;
                $scope.ALL_FILE_TYPE_KEY = $scope.SEARCH_FILE_TYPES_ARRAY[0].key;
                $scope.NONE_SEARCH_SCOPE_KEY = $scope.SEARCH_SCOPES_ARRAY[0].key;
                loadAdvanceOptionsDefaultValues();
                main();

                function loadAdvanceOptionsDefaultValues(){
                  $scope.searchForm = {
                      selectedLocation: $scope.ALL_LOCATION_KEY,
                      selectedTime: $scope.ALL_TIME_KEY,
                      startDate: null,
                      endDate: null,
                      selectedFiletypeOption: $scope.ALL_FILE_TYPE_KEY,
                      selectedFiletypes: { all: true },
                      fileExtension: null,
                      selectedScopes: { none: true },
                      ownerOrPerson: null,
                      selectedOwners: {}
                  };
                }

                $scope.isValidLocation = function(locationKey) {
                      if(locationKey == $scope.CURRENT_FOLDER_KEY && !$scope.searchInfo.currentFolderId) {
                          return false;
                      } else {
                          return true;
                      }
                  };

                $scope.setInitialStartDate = function() {
                    if (!$scope.searchForm.startDate) {
                        var now = new Date();
                        $scope.searchForm.startDate = now;
                    }
                };

                $scope.setInitialEndDate = function() {
                    if (!$scope.searchForm.endDate) {
                        var now = new Date();
                        $scope.searchForm.endDate = now;
                    }
                };

                $scope.checkAllFiletypes = function(changedFiletype) {
                    checkAllCheckbox(changedFiletype, $scope.ALL_FILE_TYPE_KEY, $scope.searchForm.selectedFiletypes);
                    // Verify that file extension input is empty to check 'All' option
                    $scope.searchForm.selectedFiletypes[$scope.ALL_FILE_TYPE_KEY] =
                      ($scope.searchForm.selectedFiletypes[$scope.ALL_FILE_TYPE_KEY] && !$scope.searchForm.fileExtension);

                    // clear file extension input
                    if (changedFiletype == $scope.ALL_FILE_TYPE_KEY) {
                        $scope.searchForm.fileExtension = '';
                        $scope.searchForm.selectedFiletypes[$scope.ALL_FILE_TYPE_KEY] = true;
                    }
                };

                $scope.checkAllScopes = function(changedScope) {
                    checkAllCheckbox(changedScope, $scope.NONE_SEARCH_SCOPE_KEY, $scope.searchForm.selectedScopes);
                };

                function checkAllCheckbox(changedCheckboxKey, allKey, listOfCheckbox) {
                    // If 'all' is selected, clean other values
                    if (changedCheckboxKey === allKey && listOfCheckbox[allKey]) {
                        for (var key in listOfCheckbox){
                            if(key === allKey) continue;

                            listOfCheckbox[key] = false;
                        }
                        return;
                    }

                    clearAllBox(allKey, listOfCheckbox);
                }

                function clearAllBox(allKey, listOfCheckbox) {
                    var isAll = true;
                    angular.forEach(listOfCheckbox, function(isSelected, key){
                        if (key !== allKey) {
                            isAll = isAll && !isSelected;
                        }
                    });
                    listOfCheckbox[allKey] = isAll;
                }

                $scope.updateAllBox = function(){
                    updateAllBoxUsingFileExtention();
                };

                function updateAllBoxUsingFileExtention() {
                    if ($scope.searchForm.fileExtension) {
                        $scope.searchForm.selectedFiletypes[$scope.ALL_FILE_TYPE_KEY] = false;
                    } else {
                        clearAllBox($scope.ALL_FILE_TYPE_KEY, $scope.searchForm.selectedFiletypes);
                    }
                }

                $scope.isAllowedScope = function(scopeKey) {
                    if(!$rootScope.isContentSearchEnabled &&
                      (scopeKey == SearchCommons.SEARCH_FIXED_OPTIONS.SCOPE.CONTENT ||
                       scopeKey == SearchCommons.SEARCH_FIXED_OPTIONS.SCOPE.COMMENTS)) {

                         return false;
                    }

                    return true;
                };

                $scope.searchUsers = function(query) {
                    var deferred = $q.defer(),
                        searchUsersParams = {
                            excludeSelf: false,
                            includeInactiveUsers: false,
                            currentUsername: authenticatedUser.getUserInfo().Username,
                            reuseLastSearchOnError: true
                        };


                    TypeaheadService.searchUsers(query, searchUsersParams).then(
                        function resolveSuccess(userCollaboratorWrappers) {
                            deferred.resolve(userCollaboratorWrappers);
                        },
                        function resolveFailure() {
                            deferred.resolve([]);
                        });

                    return deferred.promise;
                };

                $scope.typeAheadSelect = function(userWrapper) {
                    $scope.searchForm.ownerOrPerson = '';

                    if (!userWrapper || !userWrapper.metadata || !userWrapper.metadata.EmailAddress){
                        $log.error("Invalid user name for search owner");
                        MessageManager.addErrorMessage(MessageProvider.searchInvalidUserName);
                        return;
                    } else if ($scope.searchForm.selectedOwners[userWrapper.metadata.EmailAddress]) {
                        MessageManager.addErrorMessage(MessageProvider.searchUserAlreadySelected);
                        return;
                    }
                    // we use a dictionary to avoid having duplicated values and
                    // to make a fast iteration of elements in ng-repeat
                    // We don't need the value of the key, so we assign {}
                    $scope.searchForm.selectedOwners[userWrapper.metadata.EmailAddress] = {};
                };

                $scope.removeOwnerFromList = function(ownerEmail) {
                    delete $scope.searchForm.selectedOwners[ownerEmail];
                };

                $scope.removeOwnerFromListOnSpaceEnter = function(ownerEmail, event) {
                    var KEYCODE_ENTER = 13, KEYCODE_SPACE = 32;
                    if (event.keyCode === KEYCODE_ENTER || event.keyCode === KEYCODE_SPACE) {
                        $scope.removeOwnerFromList(ownerEmail);
                    }
                };

                function cleanAdvanceOptionsInMenu(advanceOptionsRequest) {
                    delete advanceOptionsRequest[$scope.KEYWORDS.LOCATION];
                    delete advanceOptionsRequest[$scope.KEYWORDS.OWNED_BY];
                    delete advanceOptionsRequest[$scope.KEYWORDS.START_DATE];
                    delete advanceOptionsRequest[$scope.KEYWORDS.END_DATE];
                    delete advanceOptionsRequest[$scope.KEYWORDS.FILE_TYPE];
                    delete advanceOptionsRequest[$scope.KEYWORDS.SCOPE];
                }

                function cleanKeywordsOptionsValue(keywordsOptionsValue) {
                    delete keywordsOptionsValue[$scope.KEYWORDS.LOCATION];
                }

                $scope.submitAdvanceSearch = function() {

                    $log.info("Submit advance search request...");

                    var normalizedQuery = QuerySearchManager.toNormalQuery($scope.searchInfo.query);
                    var advanceOptionsRequest = QuerySearchManager.parseNormalizedQueryToKeywordsMap(normalizedQuery);

                    // Clean advance options. If they are selected in menu, the will be set
                    cleanAdvanceOptionsInMenu(advanceOptionsRequest);
                    cleanKeywordsOptionsValue($scope.keywordsOptionsValue);

                    if ($scope.searchForm.selectedLocation != $scope.ALL_LOCATION_KEY) {
                        advanceOptionsRequest[$scope.KEYWORDS.LOCATION] = $scope.searchForm.selectedLocation;

                        if ($scope.searchForm.selectedLocation == $scope.CURRENT_FOLDER_KEY) {
                            $scope.keywordsOptionsValue[$scope.KEYWORDS.LOCATION] = $scope.searchInfo.currentFolderId;
                        }
                    }

                    if ($scope.searchForm.selectedTime != $scope.ALL_TIME_KEY) {
                        if ($scope.searchForm.selectedTime != $scope.CUSTOM_TIME.key){
                            advanceOptionsRequest[$scope.KEYWORDS.START_DATE] = $scope.searchForm.selectedTime;
                        } else {
                            //Validate one of the range date is valid
                            if ($scope.searchForm.startDate) {
                                $scope.searchForm.startDate.setHours(1);
                                // Assinging selected date with format YYYY-MM-DD
                                advanceOptionsRequest[$scope.KEYWORDS.START_DATE] = encloseInQuotes( $.datepicker.formatDate($scope.dateFormat, $scope.searchForm.startDate) );
                            }

                            if ($scope.searchForm.endDate) {
                                $scope.searchForm.endDate.setHours(23);
                                // Assinging selected date with format YYYY-MM-DD
                                advanceOptionsRequest[$scope.KEYWORDS.END_DATE] = encloseInQuotes( $.datepicker.formatDate($scope.dateFormat, $scope.searchForm.endDate) );
                            }

                            if ($scope.searchForm.startDate && $scope.searchForm.endDate &&
                                       $scope.searchForm.startDate.getTime() > $scope.searchForm.endDate.getTime()) {
                                MessageManager.addErrorMessage(MessageProvider.searchStartEndAfterEndDateFailure);
                                return;
                            }
                        }
                    }

                    if ($scope.searchForm.selectedFiletypeOption === $scope.FOLDERS_FILE_TYPE.key){
                        advanceOptionsRequest[$scope.KEYWORDS.FILE_TYPE] = $scope.searchForm.selectedFiletypeOption;

                    } else if ($scope.searchForm.selectedFiletypeOption === $scope.FILES_FILE_TYPE.key){

                        if ($scope.searchForm.selectedFiletypes[$scope.ALL_FILE_TYPE_KEY]) {
                            advanceOptionsRequest[$scope.KEYWORDS.FILE_TYPE] = $scope.searchForm.selectedFiletypeOption;
                        } else {

                            var selectedFiletypesList = [];
                            for(var fileTypeKey in $scope.searchForm.selectedFiletypes){
                                if($scope.searchForm.selectedFiletypes[fileTypeKey] && fileTypeKey !== $scope.ALL_FILE_TYPE_KEY) {
                                    selectedFiletypesList.push(fileTypeKey);
                                }
                            }
                            if ($scope.searchForm.fileExtension) {
                                // Replace spaces for empty string
                                var fileExtensionArr = $scope.searchForm.fileExtension.replace(/\s/g, "").replace(SIMPLE_QUOTES_REGEX, "").split(",");
                                fileExtensionArr = _.map(fileExtensionArr, function(fe){
                                    return encloseInQuotes(fe);
                                });
                                selectedFiletypesList = selectedFiletypesList.concat(fileExtensionArr);
                            }
                            if(selectedFiletypesList.length > 0){
                                advanceOptionsRequest[$scope.KEYWORDS.FILE_TYPE] = selectedFiletypesList.join(",") ;
                            }
                        }
                    }

                    var selectedScopesList = [];
                    for(var scopeKey in $scope.searchForm.selectedScopes){
                        if($scope.searchForm.selectedScopes[scopeKey] && scopeKey !== $scope.NONE_SEARCH_SCOPE_KEY) {
                            selectedScopesList.push(scopeKey);
                        }
                    }
                    if(selectedScopesList.length > 0){
                        advanceOptionsRequest[$scope.KEYWORDS.SCOPE] = selectedScopesList.join(",");
                    }

                    var ownersEmails = [];
                    for (var email in $scope.searchForm.selectedOwners) {
                        ownersEmails.push(encloseInQuotes(email));
                    }
                    if (ownersEmails.length > 0) {
                        advanceOptionsRequest[$scope.KEYWORDS.OWNED_BY] = ownersEmails.join(",");
                    }

                    var query = "";
                    if (advanceOptionsRequest.search_text || advanceOptionsRequest.search_text === "") {
                        query = advanceOptionsRequest.search_text;
                        delete advanceOptionsRequest.search_text;
                    }
                    query += " " + QuerySearchManager.createURLQueryFromKeywordsMap(advanceOptionsRequest);
                    query = encodeURIComponent(query.trim());

                    $scope.setSearchUrl(query, $scope.keywordsOptionsValue);
                };

                // MAIN
                function main(){
                    // Load values to advance search modal
                    if ($scope.searchInfo.urlQuery) {
                        // If there is a search query in URL, get that query and map the keywords in it to a map
                        // That map will be used to load info in advance search modal
                        $log.info("Loading values into advance search menu, using query in URL: " + $scope.searchInfo.urlQuery);
                        var keywordsMap = QuerySearchManager.parseNormalizedQueryToKeywordsMap($scope.searchInfo.urlQuery);
                        loadAdvanceOptionsUsingUrlMap(keywordsMap);
                    }
                }

                // Display the options that were used to perform search, using a map retrieved from the query in the URL.
                // So, if the user performed an search under 'my_docs'. It is retrieved from the url, and then it displays
                // the selected option in the menu
                function loadAdvanceOptionsUsingUrlMap(optionsMap) {

                    if (optionsMap.hasOwnProperty($scope.KEYWORDS.LOCATION)) {
                        $scope.searchForm.selectedLocation = optionsMap[$scope.KEYWORDS.LOCATION];

                        if (!SearchCommons.SEARCH_LOCATIONS[$scope.searchForm.selectedLocation]) {
                            $scope.searchForm.selectedLocation = $scope.ALL_LOCATION_KEY;
                        }
                    }

                    if (optionsMap.hasOwnProperty($scope.KEYWORDS.END_DATE)) {
                        $scope.searchForm.selectedTime = $scope.CUSTOM_TIME.key;
                        $scope.searchForm.endDate = QuerySearchManager.parseDate(optionsMap[$scope.KEYWORDS.END_DATE]);
                    }
                    if (optionsMap.hasOwnProperty($scope.KEYWORDS.START_DATE)) {
                        if ($scope.searchForm.selectedTime == $scope.CUSTOM_TIME.key) {
                            $scope.searchForm.startDate = QuerySearchManager.parseTimeValueToDate(optionsMap[$scope.KEYWORDS.START_DATE]);

                        } else {
                            $scope.searchForm.selectedTime = optionsMap[$scope.KEYWORDS.START_DATE];

                            if (!SearchCommons.SEARCH_TIMES[$scope.searchForm.selectedTime]) {
                                $scope.searchForm.startDate = QuerySearchManager.parseDate(optionsMap[$scope.KEYWORDS.START_DATE]);
                                $scope.searchForm.selectedTime = $scope.CUSTOM_TIME.key;
                            }
                        }
                    }

                    if (optionsMap.hasOwnProperty($scope.KEYWORDS.FILE_TYPE)) {

                        var filetypeOption = optionsMap[$scope.KEYWORDS.FILE_TYPE];
                        if (filetypeOption === $scope.FOLDERS_FILE_TYPE.key || filetypeOption === $scope.FILES_FILE_TYPE.key) {
                            $scope.searchForm.selectedFiletypeOption = filetypeOption;

                        } else {
                            $scope.searchForm.selectedFiletypeOption = $scope.FILES_FILE_TYPE.key;

                            var filetypesList = optionsMap[$scope.KEYWORDS.FILE_TYPE].split(",");
                            var notCustomFileTypes = [];
                            for(var idx in filetypesList){
                                var filetype = filetypesList[idx];
                                if(SearchCommons.SEARCH_FILE_TYPES[filetype] && filetype != $scope.ALL_FILE_TYPE_KEY){
                                    $scope.searchForm.selectedFiletypes[filetype] = true;
                                } else {
                                    notCustomFileTypes.push(filetype);
                                }
                            }
                            if (notCustomFileTypes.length > 0) {
                                $scope.searchForm.fileExtension = notCustomFileTypes.join(", ").replace(SIMPLE_QUOTES_REGEX, "");
                            }
                            updateAllBoxUsingFileExtention();
                        }
                    }

                    if (optionsMap.hasOwnProperty($scope.KEYWORDS.SCOPE)) {
                        var scopesList = optionsMap[$scope.KEYWORDS.SCOPE].split(",");

                        for (var i in scopesList) {
                            var searchScope = scopesList[i];
                            if (SearchCommons.SEARCH_SCOPES[searchScope] && searchScope != $scope.NONE_SEARCH_SCOPE_KEY){
                                $scope.searchForm.selectedScopes[searchScope] = true;
                            }
                        }
                        clearAllBox($scope.NONE_SEARCH_SCOPE_KEY, $scope.searchForm.selectedScopes);
                    }

                    if (optionsMap.hasOwnProperty($scope.KEYWORDS.OWNED_BY)) {

                        var owners = optionsMap[$scope.KEYWORDS.OWNED_BY].replace(SIMPLE_QUOTES_REGEX, "").split(",");
                        owners.forEach(function(element) {
                            $scope.searchForm.selectedOwners[element] = {};
                        });
                    }
                }

                function encloseInQuotes(value) {
                    return "'" + value + "'";
                }

                angular.element('#search_button').on('keydown', focusSearchBoxOnTab);
                angular.element('#search_box').on('keydown', focusSearchButtonOnShiftTab);

            }
        };
    }]);
}());
